import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiPhone } from 'react-icons/fi';
import logo from '../../assets/logo.png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Our Projects', path: '/projects' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const linkClass = ({ isActive }) =>
    [
      'text-sm font-medium transition-colors',
      isActive
        ? 'text-gradient-brand'
        : 'text-gray-300 hover:text-brand-amber',
    ].join(' ');

  const mobileLinkClass = ({ isActive }) =>
    [
      'py-2 block',
      isActive ? 'text-brand-yellow font-semibold' : 'text-gray-300 hover:text-brand-amber',
    ].join(' ');

  return (
    <header className="sticky top-0 z-50 bg-surface/95 backdrop-blur-md border-b border-white/5">
      <div
        className="h-1 w-full bg-gradient-to-r from-brand-orange via-brand-amber to-brand-yellow"
        aria-hidden
      />
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2 group">
          <img
            src={logo}
            alt="Shyam Advertising Logo"
            className="h-12 w-auto drop-shadow-[0_0_12px_rgba(234,88,12,0.35)] transition-transform group-hover:scale-[1.02]"
          />
        </Link>

        <nav className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path} className={linkClass}>
              {link.name}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center space-x-4">
          <a
            href="tel:9821466536"
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-gradient-brand px-4 py-2 text-sm font-semibold text-black shadow-brand-glow hover:opacity-95 transition-opacity"
          >
            <FiPhone className="shrink-0" />
            <span>9821466536</span>
          </a>

          <button
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white text-2xl p-1 rounded-lg hover:bg-white/5"
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden border-t border-white/10 bg-surface py-4">
          <div className="container mx-auto px-4 flex flex-col space-y-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={mobileLinkClass}
              >
                {link.name}
              </NavLink>
            ))}
            <a
              href="tel:9821466536"
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-brand py-3 text-sm font-semibold text-black"
            >
              <FiPhone />
              9821466536
            </a>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
